import Swiper from "swiper";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import { isHTMLElement } from "src/utils";

import type { SwiperOptions } from "swiper/types";

const DEFAULT_SELECTORS = {
  WRAPPER: ".swiper-wrapper",
  CONTAINER: ".swiper",
  PAGINATION: ".swiper-pagination",
  PREV_BUTTON: ".swiper-button-prev",
  NEXT_BUTTON: ".swiper-button-next",
  SCROLLBAR: ".swiper-scrollbar",
};

export type InitSwiperProps = {
  wrapperSelector?: string;
  containerSelector?: string;
  paginationSelector?: string;
  prevButtonSelector?: string;
  nextButtonSelector?: string;
  scrollBarSelector?: string;
};

export const initSwipers = (
  {
    wrapperSelector = DEFAULT_SELECTORS.WRAPPER,
    containerSelector = DEFAULT_SELECTORS.CONTAINER,
    paginationSelector = DEFAULT_SELECTORS.PAGINATION,
    prevButtonSelector = DEFAULT_SELECTORS.PREV_BUTTON,
    nextButtonSelector = DEFAULT_SELECTORS.NEXT_BUTTON,
    scrollBarSelector = DEFAULT_SELECTORS.SCROLLBAR,
  }: InitSwiperProps,
  swiperDefaultOptions?: SwiperOptions
) => {
  document.querySelectorAll(wrapperSelector).forEach((wrapperEl) => {
    const el = wrapperEl.querySelector(containerSelector);

    if (!isHTMLElement(el)) return;
    if (el.classList.contains("swiper-initialized")) return;

    const pagination = wrapperEl.querySelector(paginationSelector);
    const prevButton = wrapperEl.querySelector(prevButtonSelector);
    const nextButton = wrapperEl.querySelector(nextButtonSelector);
    const scrollbar = wrapperEl.querySelector(scrollBarSelector);

    const modules: SwiperOptions["modules"] = [];

    const swiperOptions: SwiperOptions = {
      loop: true,
      ...swiperDefaultOptions,
    };

    if (isHTMLElement(prevButton) || isHTMLElement(nextButton)) {
      modules.push(Navigation);
      swiperOptions.navigation = {
        ...(isHTMLElement(prevButton) && { prevEl: prevButton }),
        ...(isHTMLElement(nextButton) && { nextEl: nextButton }),
      };
    }

    if (isHTMLElement(pagination)) {
      modules.push(Pagination);
      swiperOptions.pagination = { el: pagination };
    }

    if (isHTMLElement(scrollbar)) {
      modules.push(Scrollbar);
      swiperOptions.scrollbar = { el: scrollbar };
    }

    swiperOptions.modules = modules;

    new Swiper(el, swiperOptions);
  });
};
